import React from "react";


const HtmlRenderActionICon: React.FC = () => {
 
  return (
    <>
      <div className="d-flex justify-content-center" >
        <i title="Actions" className="bi bi-lightning-fill" style={{fontSize:"24px", marginBottom:"9px"}}></i>
      </div>
    </>
  );
};

export default HtmlRenderActionICon;
